




















































































































import { Vue, Component } from 'vue-property-decorator'
import { draftColumns } from '../config/colums'
import {
  queryProperNoun,
  changeStatus,
  editCategory,
  queryCategory,
  editProperNoun,
  removeProperNoun
} from '../../../service/proper'

@Component
export default class DraftLibrary extends Vue {
  private typeOptions: any[] = []
  private statusOptions: any[] = [
    { label: '不限', value: '' },
    { label: '未发布', value: 'edit' },
    { label: '已发布', value: 'online' }
  ]
  private word: string = ''
  private categoryId: string = ''
  private status: string = ''
  private draftColumns: any[] = draftColumns
  private dataSource: any[] = []
  private pagination: any = {
    current: 1,
    pageSize: 20,
    total: 0,
    showTotal: (total) => `共 ${total} 条`
  }
  private beforeCreate() {
    console.log('init form')
    ;(this as any).form = this.$form.createForm(this)
  }
  private async renderCategories() {
    const res = await queryCategory({})
    const { success, data } = res

    if (success) {
      this.typeOptions = data
    }
  }
  private async renderList(page: number) {
    const options = {
      word: this.word,
      category_id: this.categoryId,
      status: this.status,
      ext_word_type: 0,
      page
    }
    const { list, total } = await queryProperNoun(options)

    this.pagination.current = page
    this.pagination.total = total
    this.dataSource = list
  }
  private handleTableChange(pagination) {
    this.renderList(pagination.current)
  }
  private async changeProperNounStatus(id, status) {
    const options = {
      ids: [id],
      status
    }
    const res = await changeStatus(options)

    if (res.success) {
      this.$message.success(status === 'edit' ? '取消发布成功' : '发布成功')
      this.renderList(this.pagination.current)
    } else {
      this.$message.error(status === 'edit' ? '取消发布失败' : '发布失败')
    }
  }
  private handleSubmit() {
    this.renderList(1)
  }
  private mounted() {
    this.renderCategories()
    this.renderList(1)
  }
  // 创建类别
  private isTypeModalVisibale: boolean = false
  private typeModalConfirmLoading: boolean = false
  private setCategory() {
    this.isTypeModalVisibale = true
  }
  private async handleTypeModalOk(e) {
    this.typeModalConfirmLoading = true
    const options = {
      name: this.categoryName
    }
    const res = await editCategory(options)

    if (res.success) {
      this.$message.success('创建类别成功')
      this.typeModalConfirmLoading = false
      this.categoryName = ''
      this.renderCategories()
    } else {
      this.$message.error('创建类别失败')
    }
    this.isTypeModalVisibale = false
  }
  private handleTypeModalCancel(e) {
    this.isTypeModalVisibale = false
  }
  private categoryName: string = ''
  // 设置专有名词
  private isNameModalVisibale: boolean = false
  private nameModalConfirmLoading: boolean = false
  private setProperNoun() {
    this.isNameModalVisibale = true
  }
  private async handleNameModalOk(e) {
    const word: string = this.properNounValue
    const categoryId: string = this.properNounCategory

    if (!word) {
      this.$message.info('请输入专有名词')
      return
    }

    if (!categoryId) {
      this.$message.info('请选择分类')
      return
    }

    const options = {
      word,
      category_id: categoryId
    }

    if (this.currentProperNounId) {
      Object.assign(options, { id: this.currentProperNounId })
    }

    this.nameModalConfirmLoading = true

    const res = await editProperNoun(options)

    if (res.success) {
      this.$message.success('设置专有名词成功!')
      this.renderList(1)
    } else {
      this.$message.error('设置专有名词失败')
    }

    this.properNounCategory = ''
    this.properNounValue = ''
    this.currentProperNounId = ''
    this.isNameModalVisibale = false
    this.nameModalConfirmLoading = false
  }
  private handleNameModalCancel(e) {
    this.isNameModalVisibale = false
    this.nameModalConfirmLoading = false
  }
  private properNounValue: string = ''
  private properNounCategory: string = ''
  // 操作专有名词条目
  private currentProperNounId: string = ''
  private editProperNounItem(record) {
    this.currentProperNounId = record.id
    this.properNounCategory = record.category.id || ''
    this.properNounValue = record.word
    this.setProperNoun()
  }
  private async removeProperNounItem(id) {
    const options = {
      ids: [id]
    }
    const res = await removeProperNoun(options)

    if (res.success) {
      this.$message.success('删除专有名词成功')
      this.renderList(this.pagination.current)
    } else {
      this.$message.error('删除专有名词失败')
    }
  }
}
